// Tiny sound helpers. Audio only ever plays in response to a user gesture
// (a click, or a hover after the first interaction), so it never autoplays.
let audio;

export const playBark = () => {
  try {
    if (typeof window === "undefined") return;
    if (!audio) {
      audio = new Audio("/bark.wav");
      audio.preload = "auto";
      audio.volume = 0.45;
    }
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch {
    /* ignore playback errors */
  }
};

// Soft synthesized "tick" for playful UI hovers (e.g. service cards).
// Uses the Web Audio API so no asset download is needed. Very low volume.
let audioCtx;

export const playTick = () => {
  try {
    if (typeof window === "undefined") return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!audioCtx) audioCtx = new AC();
    // Resume if the browser suspended it before the first user gesture.
    if (audioCtx.state === "suspended") audioCtx.resume().catch(() => {});

    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();

    osc.type = "triangle";
    osc.frequency.setValueAtTime(1650, now);
    osc.frequency.exponentialRampToValueAtTime(880, now + 0.05);

    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.09, now + 0.006);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.09);

    osc.connect(gain).connect(audioCtx.destination);
    osc.start(now);
    osc.stop(now + 0.1);
  } catch {
    /* ignore playback errors */
  }
};
